import React from 'react';

import { formatDate } from 'helpers/dates-formatter';


import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import Author from 'containers/user/learn/components/author/author';

import Icons from 'assets/icons';

interface AuthorAvatarData {
  attributes?: { url?: string };
}

interface BasicInfoProps {
  authorName?: string;
  authorPosition?: string;
  authorAvatar?: { data?: AuthorAvatarData[] };
  readTime?: number;
  updatedAt?: string;
}

const BasicInfo = ({
  authorName = '',
  authorPosition = '',
  authorAvatar,
  readTime = 1,
  updatedAt = '',
}: BasicInfoProps): React.JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      pt: 1.5,
      '@media (min-width: 375px)': { flexDirection: 'column', mb: 3 },
      '@media (min-width: 780px)': { flexDirection: 'row' },
      '@media (min-width: 960px)': { mb: 4 },
      '@media (min-width: 1280px)': { flexDirection: 'column' },
    }}
  >
    <Author
      avatar={authorAvatar?.data?.[0]?.attributes?.url}
      name={authorName}
      position={authorPosition}
    />
    <Stack direction="row" sx={{ color: 'tokens.navy.500', pt: 2 }}>
      <Stack direction="row" sx={{ alignItems: 'center', mr: 3 }}>
        <Icons.Calendar customClass="mr-1" />
        {`Updated on ${formatDate(updatedAt, 'MMM D, YYYY')}`}
      </Stack>
      <Stack direction="row" sx={{ alignItems: 'center' }}>
        <Icons.OpenBook customClass="mt-0.5 mr-1" />
        {`${readTime} min`}
      </Stack>
    </Stack>
  </Box>
);

export default BasicInfo;
